export const TestResultSectionDataP721 = (selectedTag, formData) => ({
        rows: [
            {
                key: 1,
                fields: [{
                    key: 'F143HmireadingAfterTest',
                    label: 'HMI Displacement Reading After Test (HMI EU)',
                    value: formData.F143HmireadingAfterTest,
                    isRequired: true,
                    xs: 4,
                    type: 'number',
                    direction: 'rtl',
                    marginRight: '0.25rem',
                    maxLength: '10',
                    labelWidth: '51%',
                    width: '49%',
                    height: '1.62rem',
                    textAlign: 'center'
                },
                {
                    key: 'Nodata',
                    isLabel: true,
                    xs: 1
                },
                {
                    key: 'F752GapVoltageAfterTestLabel',
                    label: 'Gap Voltage After Test (V)',
                    labelWidth: '98%',
                    xs: 3,
                    padding: '5px 0 0 0',
                    isLabel: 'true',
                    textAlign: 'end',
                    fontSize: '9pt',
                    fontWeight: '600'
                },
                {
                    key: 'F752GapVoltageAfterTest',
                    value: formData.F752GapVoltageAfterTest,
                    type: 'number',
                    maxLength: '10',
                    isRequired: true,
                    labelWidth: '0',
                    xs: 4,
                    height: '1.62rem',
                    textAlign: 'center',
                    width: '100%',
                    marginLeft: '0.8px'
                }]
            }]
    });
